<template>
<div class='pa-6'>
  <v-card class='pa-4'>
  <v-card-title class=''>API一覧</v-card-title>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">タイプ</th>
          <th class="text-left">URL</th>
          <th class="text-left">詳細</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in api" :key="item.name">
          <td>{{ item.type }}</td>
          <td>{{ item.url }}</td>
          <td>{{ item.desc }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>


  <v-card-title>AppMedia側からリクエスト</v-card-title>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">タイプ</th>
          <th class="text-left">URL</th>
          <th class="text-left">詳細</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>GET</td>
          <td>(例)https://tool.matomeroyal.com/wp-content/themes/tool/csv/data_0-100.json</td>
          <td>AppMedia側からリクエスト設定一覧を取得</td>
        </tr>
      </tbody>
    </template>

    
  </v-simple-table>


  </v-card>
  </div>

</template>


<script>
export default {
  data() {
    return {
      api: [
        {
          type: "GET",
          url: process.env.VUE_APP_REDIRECT_API_LIST,
          desc: "設定一覧"
        },
        {
          type: "POST",
          url: process.env.VUE_APP_REDIRECT_API_UPDATE,
          desc: "該当データの更新(該当アイテムデータをPOST)"
        },
        {
          type: "POST",
          url: process.env.VUE_APP_REDIRECT_API_DELETE,
          desc: "該当データの削除(該当アイテムデータをPOST)"
        },
        {
          type: "GET",
          url:
            process.env.VUE_APP_REDIRECT_API_DETAIL,
          desc: "詳細クリック数取得"
        }
      ]
    };
  },

};
</script>